import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Error } from './error.types'

import { MedicalRecordPayload } from 'models/MedicalRecord'

interface UpdateDraftProps {
  formUuid: string
  payload: MedicalRecordPayload
}

export async function updateDraft({ formUuid, payload }: UpdateDraftProps): Promise<void> {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_FORMS_UPDATE_DRAFT(formUuid)

  return new Promise<void> ((resolve, reject) => {
    axios.put(endpoint, payload)
      .then(() => resolve(null))
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}